import React from 'react';
import PropTypes from 'prop-types';
import style from './List.module.scss';

function List({ title = '', type, listData }) {
  function unorderedList(data) {
    return (
      <ul className={style.ul}>
        {data.map((item) => (
          <li key={item.id} className={style.item}>
            {item.text}
            {item.subList && List(item.subList)}
          </li>
        ))}
      </ul>
    );
  }

  function orderedList(data) {
    return (
      <ol className={style.ol}>
        {data.map((item) => (
          <li key={item.id} className={style.item}>
            {item.text}

            {item.subList && List(item.subList)}
          </li>
        ))}
      </ol>
    );
  }

  function printList(data) {
    return data.type === 'ol'
      ? orderedList(data.listData)
      : unorderedList(data.listData);
  }

  return (
    <section className={style.section}>
      {title !== '' && <h3 className={style.title}>{title}</h3>}
      {printList({ type, listData })}
    </section>
  );
}
const typeProp = PropTypes.oneOf(['ol', 'ul']);

const listPropShape = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

const listProp = PropTypes.arrayOf(PropTypes.shape(listPropShape));

const subListProp = PropTypes.shape({
  type: typeProp.isRequired,
  listData: listProp,
});

listPropShape.subList = subListProp;

List.propTypes = {
  title: PropTypes.string,
  type: typeProp.isRequired,
  listData: listProp.isRequired,
};

export default List;
